// Code generated by Prismic. DO NOT EDIT.

import CategoriesAndThematiquesList from "./CategoriesAndThematiquesList";
import Cta from "./Cta";
import FeaturedInspirationList from "./FeaturedInspirationList";
import FileList from "./FileList";
import HeroInterne from "./HeroInterne";
import Highlight from "./Highlight";
import InspirationCategroyGrid from "./InspirationCategroyGrid";
import InspirationGrid from "./InspirationGrid";
import InstagramFeed from "./InstagramFeed";
import NavigationItem from "./NavigationItem";
import Newsletter from "./Newsletter";
import ProductSlider from "./ProductSlider";
import ProductsAndTablesList from "./ProductsAndTablesList";
import Richtext from "./Richtext";
import SectionLinks from "./SectionLinks";
import SimilarPacks from "./SimilarPacks";
import TestimonialSlider from "./TestimonialSlider";
import TextAndImage from "./TextAndImage";

export const components = {
	categories_and_thematiques_list: CategoriesAndThematiquesList,
	cta: Cta,
	featured_inspiration_list: FeaturedInspirationList,
	file_list: FileList,
	hero_interne: HeroInterne,
	highlight: Highlight,
	inspiration_categroy_grid: InspirationCategroyGrid,
	inspiration_grid: InspirationGrid,
	instagram_feed: InstagramFeed,
	navigation_item: NavigationItem,
	newsletter: Newsletter,
	product_slider: ProductSlider,
	products_and_tables_list: ProductsAndTablesList,
	richtext: Richtext,
	section_links: SectionLinks,
	similar_packs: SimilarPacks,
	testimonial_slider: TestimonialSlider,
	text_and_image: TextAndImage
};